module.exports = __webpack_public_path__ + "static/media/exclamationSign.8dabf6ce.svg";